<div class="body">
  <form class="container-fluid needs-validation">
    <div class="row">
      <div class="col-lg-8 col-12">
        <app-custom-select [labelText]="'Tipo Doc. Comercial'" [list]="listBussinessDocumentsTypes" [required]="true"
          (onChangeSelect)="getBussinessDocumentsType($event)"></app-custom-select>
      </div>
      <div class="col-12 col-lg-4">
        <app-custom-input-number [labelText]="'Número'" [required]="true"
          (onChangeNumber)="consecutive = $event"></app-custom-input-number>
      </div>
    </div>
  </form>
</div>
<div class="mt-2">
  <app-custom-button [title]="'Aceptar'" [label]="'Aceptar'" [variant]="undefined"
    (onClick)="copyDocumentSupport()"></app-custom-button>
</div>